import React from 'react'
import {LinkComponent, SocialComponent} from '../utils/links'
import {IoMenu} from 'react-icons/io5'
import {useGlobalContext} from '../context'


function Navbar() {
    const {openSidebar} = useGlobalContext();
    return (
        <nav className="navbar">
            <LinkComponent classStyle="nav-box"/>
            <SocialComponent classStyle="social-box"/>
            <div className="sidebar-button">
                <IoMenu className="social-icon button-open" onClick={openSidebar}/>
            </div>
            
            
        </nav>
    )
}

export default Navbar
